/**
 * Status for Docebo enrollments
 */
export enum DoceboEnrollmentStatus {
    COMPLETED = 'completed',
    IN_PROGRESS = 'in_progress',
    ENROLLED = 'enrolled',
    WAITING = 'waiting',
}
